<template>
  <div v-show="this.initialised">
    <!-- v-on:submit.prevent handles submit on pressing the Enter key -->
    <v-form ref="eaForm" v-on:submit.prevent="save()">
      <ads-expansion-panel :items="panels" v-model="openPanels">
        <template slot="contentClientDetails">
          <v-form
            ref="clientDetailsForm"
            v-on:submit.prevent="save()"
            validation-section-name="Client details"
          >
            <client-details :readonly="true" />
            
            <!-- Form needs a submit button for Enter to submit functionality -->
            <button type="sumbit" style="display: none" />
          </v-form>
        </template>
        <template slot="contentHousingDetails">
          <v-form
            ref="housingDetailsForm"
            v-on:submit.prevent="save()"
            validation-section-name="Housing details"
          >
            <housing-details :readonly="true" />
            
            <!-- Form needs a submit button for Enter to submit functionality -->
            <button type="sumbit" style="display: none" />
          </v-form>
        </template>
         <template slot="contentIncomeDetails">
          <v-form
            ref="incomeDetailsForm"
            v-on:submit.prevent="save()"
            validation-section-name="Income details"
          >
            <income-details :readonly="true" />
            
            <!-- Form needs a submit button for Enter to submit functionality -->
            <button type="sumbit" style="display: none" />
          </v-form>
        </template>
         <template slot="contentExpenseDetails">
          <v-form
            ref="expenseDetailsForm"
            v-on:submit.prevent="save()"
            validation-section-name="Expenses details"
          >
            <expense-details :readonly="true" />
            
            <!-- Form needs a submit button for Enter to submit functionality -->
            <button type="sumbit" style="display: none" />
          </v-form>
        </template>
        <template slot="contentServiceDetails">
          <v-form
            ref="serviceDetailsForm"
            v-on:submit.prevent="save()"
            validation-section-name="Service details"
          >
            <service-details :readonly="true" />
            
            <!-- Form needs a submit button for Enter to submit functionality -->
            <button type="sumbit" style="display: none" />
          </v-form>
        </template>
         <template slot="contentIncomeProofDetails">
          <v-form
            ref="incomeProofDetailsForm"
            v-on:submit.prevent="save()"
            validation-section-name="Income Proof details"
          >
            <income-proof-details :readonly="true" />
            
            <!-- Form needs a submit button for Enter to submit functionality -->
            <button type="sumbit" style="display: none" />
          </v-form>
           </template>
           <template slot="contentServiceProofDetails">
          <v-form
            ref="serviceProofDetailsForm"
            v-on:submit.prevent="save()"
            validation-section-name="Service Proof details"
          >
            <service-proof-details :readonly="true" />
            
            <!-- Form needs a submit button for Enter to submit functionality -->
            <button type="sumbit" style="display: none" />
          </v-form>
           </template>
      </ads-expansion-panel>      
      <!-- v-on:reset.prevent in the v-form wasn't working, so I have to handle it here -->
      <save-cancel v-if="isEditing" @cancel="cancel" />
    </v-form>
    <errors-dialog
      v-model="showErrors"
      :errors="errors"
      @close="closeErrorsDialog"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import  AdsExpansionPanel  from '@/components/app/AdsExpansionPanel.vue'
import { getFormErrors, focusOnFirstError } from '@/helpers/form'

import ClientDetails from './ClientDetails'
import HousingDetails from './HousingDetails'
import IncomeDetails from './IncomeDetails'
import ExpenseDetails from './ExpenseDetails'
import ServiceDetails from './ServiceDetails'
import IncomeProofDetails from './IncomeProofDetails'
import ServiceProofDetails from './ServiceProofDetails'
import ErrorsDialog from './ErrorsDialog'
import SaveCancel from '@/components/form/SaveCancel'
import { EA_STATUSES_FOR_OPT_OUT_EMAIL } from '@/constants'

export default {
  name: 'EaForm',
  components: {
    AdsExpansionPanel,
    SaveCancel,
    ClientDetails,
    HousingDetails,
    IncomeDetails,    
    ExpenseDetails,
    ServiceDetails,
    IncomeProofDetails,
    ServiceProofDetails,
    ErrorsDialog
  },
  data() {
    return {
      clientValid: true,      
      openPanels: [],
      initialised: false,
      errors: [],
      showErrors: false,
      test: ''
    }
  },
  computed: {
    ...mapGetters([
      'application',
      'isEditing',
      'referenceData',
      'isEaApplicationReadOnly'
    ]),
    panels() {
      const errorProps = { headerClass: 'sectionError', icon: 'error_outline' }
      const sections = [
        {
          id: 'ClientDetails',
          title: 'Personal Information',
         // ...(this.clientValid ? this.application.application.client : errorProps)
        },
        {
          id: 'HousingDetails',
          title: 'Housing Information',
         // ...(this.clientValid ? this.application.application.housing : errorProps)
        },  
        {
          id: 'IncomeDetails',
          title: 'Monthly Income',
         // ...(this.clientValid ? this.application.application.income : errorProps)
        },
        {
          id: 'ExpenseDetails',
          title: 'Monthly Expenses',
       //   ...(this.clientValid ? this.application.application.expenses : errorProps)
        },
        {
          id: 'ServiceDetails',
          title: 'Services Needed',
        //  ...(this.clientValid ? this.application.application.services : errorProps)
        },
        {
          id: 'IncomeProofDetails',
          title: 'Proof of Income',
         // ...(this.clientValid ? this.application.application.supportingDocuments : errorProps)
        },
       
        {
          id: 'ServiceProofDetails',
          title: 'Proof of Services',
        //  ...(this.clientValid ? this.application.application.supportingDocuments : errorProps)
        }
        // {
        //   id: 'AuthorizationDetails',
        //   title: 'Authorization',
        //   ...(this.clientValid ? this.application.application.housing : errorProps)
        // }
      ]
      return sections
    }
  },
  mounted() {
    // open and close all the panels to ensure they are rendered so we can run pre-validation
    this.openPanels = [...Array(this.panels.length).keys()]
    this.$nextTick(() => {
      this.openPanels = []

      // give the animation a chance to complete
      setTimeout(() => {
        this.initialised = true
      }, 100)
    })
  },
  methods: {
    save() {
      // A work around to update the sendPCEmail field
      const canUpdateSendPCEmail = EA_STATUSES_FOR_OPT_OUT_EMAIL.includes(
        this.application.applicationStatus
      )
      if (this.isEaApplicationReadOnly && !canUpdateSendPCEmail) {
        return
      }
      this.validate()
      if (this.errors.length) {
        this.showErrors = true
      } else {
        this.$store.dispatch('saveEaApplication')
      }
    },
    cancel() {
      this.$store.dispatch('cancelApplication')
    },
    stopEdit() {
      this.$store.commit('set', ['isEditing', false])
    },
    validate() {
      if (this.$refs.eaForm) {
        this.$refs.eaForm.validate()
      }
      if (this.$refs.clientDetailsForm) {
        this.$refs.clientDetailsForm.validate()
      }
      if (this.$refs.eaForm) {
        this.errors = getFormErrors(this.$refs.eaForm)
      }
    },
    closeErrorsDialog() {
      this.showErrors = false
      focusOnFirstError(this.$refs.eaForm)
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .v-expansion-panel-header.sectionError {
  span i {
    color: $ads-error-red;
  }
  span {
    color: $ads-error-red;
    font-weight: bold;
  }
}
.col {
  padding: 0px;
}
</style>